import type { JSX } from 'react'

export const QualityBadgeSdIcon = (): JSX.Element => (
  <use href='#qualityBadgeSdIcon' height='100%' width='100%' />
)
